import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { chatApi as n } from "@maat/api-chat";
//#region src/hooks/useInboxAssigneesQuery.ts
var r = (r) => t({
	queryKey: e.inboxAssignees(r),
	queryFn: () => n.getInboxAssignees(r),
	enabled: !!r
});
//#endregion
export { r as useInboxAssigneesQuery };
